import { useContext, useEffect, useState } from 'react';
import { HealthRiskAssessmentContext } from 'Views/HealthRiskAssessment/HealthRiskAssessment.context';
import { getPopulationActions } from 'Views/HealthRiskAssessment/HealthRiskAssessment.services';

type ExamProps = {
	name: string;
	status: string;
	externalOrders: DefaultExternalOrder[];
};

type DefaultExternalOrder = {
	serviceRequest: string;
	status: string;
};

type DefaultActivity = {
	name: string;
	status: string;
};

type EmployeeActivityProps = {
	exams: ExamProps[];
	workshops: DefaultActivity[];
	chats: DefaultActivity[];
	sessions: DefaultActivity[];
};

export const useMoreInfo = ({ employeeId }: { employeeId: string }) => {
	const { selectedGroup } = useContext(HealthRiskAssessmentContext);
	const [isLoading, setLoading] = useState<boolean>(false);

	const [employeeActivity, setEmployeeActivity] =
		useState<EmployeeActivityProps>({} as EmployeeActivityProps);

	const groupId = selectedGroup?.hraGroupCompanyId || '';

	const isEmptyData = Boolean(!Object.keys(employeeActivity).length);

	const fetchActions = async () => {
		try {
			setLoading(true);
			const { data } = await getPopulationActions(groupId, employeeId);
			setEmployeeActivity(data?.content?.activities || {});
		} catch (error: unknown) {
			console.error('Error fetching actions', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchActions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		isLoading,
		isEmptyData,
		employeeActivity,
	};
};
